import { AsiakkaanTuote, LaskunAlv, LaskunTyypit } from '@lemon/core-firebase/model/lasku'
import { NumberDate } from '@lemon/core/model/common'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'

export interface NaytettavaTuote extends AsiakkaanTuote {
  alvProsentti: number | null
  hintaVerollinen: number | null
}

export function vertaaTuotteita(a: AsiakkaanTuote, b: AsiakkaanTuote, sarake: string): number {
  switch (sarake) {
    case 'hinta':
      return (a.hinta ?? 0) - (b.hinta ?? 0)
    case 'nimi':
      return (a.nimi ?? '').toLowerCase().localeCompare((b.nimi ?? '').toLowerCase(), 'fi')
    default:
      return 0
  }
}

export function annaVerollinenHinta(hinta: number | null, alvProsentti: number | null, currencyService: CurrencyService): number | null {
  const hintaJaAlvTiedossa = currencyService.onkoNumero(hinta) && alvProsentti !== null && alvProsentti !== undefined
  return hintaJaAlvTiedossa ? currencyService.roundHalfUp(hinta + currencyService.annaAlvMaaraAlvittomastaHinnasta(hinta, alvProsentti), 2) : null
}

/** Rekisterin listoilla näytetään kotimaan tavallisen myynnin alv-kanta, koska se on tuotteen yleisin käyttö. */
export function annaNaytettavaTuote(tuote: AsiakkaanTuote, kotimaanAlvt: LaskunAlv[], currencyService: CurrencyService): NaytettavaTuote {
  const alvTunniste = tuote.alv?.[LaskunTyypit.TAVALLINEN.avain]
  const alvProsentti = kotimaanAlvt.find(alv => alv.tunniste === alvTunniste)?.prosentti ?? null
  return { ...tuote, alvProsentti, hintaVerollinen: annaVerollinenHinta(tuote.hinta, alvProsentti, currencyService) }
}

/** Alv-kanta on voimassa alku- ja loppupäivänsä välillä, molemmat mukaan lukien; puuttuva raja ei rajaa. */
export function onkoAlvVoimassa(alv: LaskunAlv, paiva: NumberDate, dateService: DateService): boolean {
  const alkanut = !alv.s || dateService.compareNumberDates(alv.s, '<=', paiva)
  const paattymatta = !alv.e || dateService.compareNumberDates(paiva, '<=', alv.e)
  return alkanut && paattymatta
}
